import { render } from "./Description.vue?vue&type=template&id=3e5ab688&scoped=true"
import script from "./Description.vue?vue&type=script&lang=js"
export * from "./Description.vue?vue&type=script&lang=js"

import "./Description.vue?vue&type=style&index=0&id=3e5ab688&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e5ab688"]])

export default __exports__